// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screen_box {\r\n\twidth: 100%;\r\n\theight: 450px;\r\n\tbackground-color: black;\n}\n.screen_box > img {\r\n\tmax-width: 100%;\n}\n[popupClose] {\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tleft: 5px;\r\n\twidth: 90%;\r\n\tfont-size: 15px;\r\n\tcolor: white;\n}\nbody {\r\n\toverflow: hidden;\n}\r\n", ""]);
// Exports
module.exports = exports;
